import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withI18n, withI18nProps } from '@lingui/react'
import { withRouter } from 'react-router'
import compose from 'lodash/fp/compose'
import isEmpty from 'lodash/isEmpty'
import Spacer from 'client/shared/blocks/spacer'
import HeaderBox from 'client/shared/boxes/header-box'
import { LayoutColumn } from 'client/shared/blocks/layout-column/layout-column'
import { ShelvesNav } from '../blocks/shelves-nav/shelves-nav'
import { DecoratorProps } from 'client/shared/decorators/ui-box'
import deviceHelper from 'shared/tools/device-helper'

import { State as AppState } from 'client/shared/reducers/app-reducer'
import { CurrentUserState } from 'client/shared/types/current-user'
import { ShelvesNavMobile } from '../blocks/shelves-nav/shelves-nav-mobile'
import {
  getUserTabs,
  hideMobileNav,
} from 'client/bookmate/reducers/shelves-reducer'
import Popup from 'client/shared/blocks/popup/popup'
import { Location } from 'client/shared/types/react-router'
import { MetaDescription } from 'client/shared/blocks/meta-description/meta-description'
import MetaTitle from 'client/shared/blocks/meta-title/meta-title'
import Footer from 'client/shared/blocks/footer/footer'
import { State } from 'shared/types/redux'

export type BookshelfTab = {
  friends?: boolean
  following?: boolean
}

export type BookshelfTopic = {
  background: { large: string }
  is_subtopic: boolean
  parent_slug: string | null
  slug: string
  title: string
  uuid: string
  language: string
}

type Props = {
  app: AppState
  currentUser: CurrentUserState
  topics: BookshelfTopic[]
  tabs?: BookshelfTab
  mobileNavShown: boolean
  location: Location
} & DecoratorProps &
  withI18nProps

class ShelvesPage extends Component<Props> {
  async componentDidMount(): Promise<void> {
    const { dispatch, tabs, currentUser } = this.props

    if (!isEmpty(tabs)) return

    if (currentUser.auth) {
      const isUserTabsPresent = [
        dispatch(getUserTabs({ topic: 'following' })),
        dispatch(getUserTabs({ topic: 'friends' })),
      ]
      await Promise.all(isUserTabsPresent)
    }
  }

  render() {
    const {
      i18n,
      app,
      currentUser,
      children,
      topics,
      dispatch,
      tabs,
      mobileNavShown,
      location: { pathname },
    } = this.props
    const isMobileSize = deviceHelper.isMobileSize(app)

    return (
      <>
        <MetaTitle disableSuffix title={i18n.t`shelf.bookshelves_meta_title`} />
        <MetaDescription
          description={i18n.t`shelf.bookshelves_meta_description`}
        />
        <HeaderBox />
        {mobileNavShown && (
          <Popup
            className="shelves-navigation__mobile"
            onClose={() => dispatch(hideMobileNav())}
          >
            <ShelvesNavMobile
              {...{
                query: app.storedQuery,
                currentUser,
                topics,
                dispatch,
                tabs,
                pathname,
              }}
            />
          </Popup>
        )}
        <Spacer size={56} />
        <LayoutColumn className="shelves__wrapper" autoWidth>
          {!isMobileSize && (
            <ShelvesNav
              i18n={i18n}
              currentUser={currentUser}
              topics={topics}
              tabs={tabs}
              query={app.storedQuery}
              pathname={pathname}
            />
          )}
          {children}
        </LayoutColumn>
        <Spacer size={140} />
        <Footer withNotice noBottomSpace />
      </>
    )
  }
}

const connectWrapper = connect((state: State) => ({
  app: state.app,
  currentUser: state.currentUser,
  topics: state.entities.shelves.topics,
  tabs: state.entities.shelves.tabs,
  mobileNavShown: state.entities.shelves.mobileNavShown,
}))

const wrappers = compose(connectWrapper, withRouter, withI18n({ update: true }))

export default wrappers(ShelvesPage)
